import React, {useCallback, useEffect, useState} from "react";
import {hasChart, mrbgStore, setChartKey} from './mrbgRedux/index.js';
import chartStyle from '../../static/css/MP_charts.module.css';

function MrbgPieChart({chartID,chartInfo,radius,emptyRadius,height}){

  if( emptyRadius==undefined )
    emptyRadius = radius/2;

  if( height==undefined )
    height = radius * 0.12;

  const
    [chartName,setChartName] = useState( mrbgStore.getState().dynamicChartKey[chartID]?.cName ),
    [pointName,setPointName] = useState( mrbgStore.getState().dynamicChartKey[chartID]?.pName ),
    [pieSlices,setPieSlices] = useState({}),
    [sliceColor,setSliceColor] = useState({}),
    createSlice = useCallback(()=>{
      var sliceNames = [];
      Object.keys(chartInfo).map(cn=>{
        sliceNames = sliceNames.concat( Object.keys(chartInfo[cn].points) )
      })
      sliceNames = [...new Set(sliceNames)]

      var
        slcD    = Object.keys(chartInfo).reduce((r, k) => ({ ...r, [k]:sliceNames.reduce((r2,k2)=>({...r2, [k2]:[]}), {}) }), {}),
        slcInfo = Object.keys(chartInfo).reduce((r, k) => ({ ...r, [k]:sliceNames.reduce((r2,k2)=>({...r2, [k2]:[]}), {}) }), {}),
        pieSlc  = {},
        slcClr;

      Object.keys(chartInfo).map(cn=>{
        var
          sum  = 0,
          quarter = {
            '1-2': [],
            '1'  : [],
            '4'  : [],
            '2'  : [],
            '2-3': [],
            '3'  : [],
            '3-4': []
          };

        if( chartInfo[cn]?.points && Object.values(chartInfo[cn].points).length && Math.max(...Object.values(chartInfo[cn].points))>chartInfo[cn].total*.75 )
          sum = chartInfo.total * .25;

        sliceNames.map(sn=>{
          var
            val            = parseInt(chartInfo[cn].points[sn]) || 0,
            arcFlag        = val>chartInfo[cn].total/2? 1: 0,
            sweepFlag      = 0,
            centerPart     = (val/2+sum)%chartInfo[cn].total,
            rotation       = (!chartInfo[cn].total)? 0: centerPart*-360/chartInfo[cn].total,
            currentQuarter = (!chartInfo[cn].total)? 0: Math.floor(centerPart/(chartInfo[cn].total*0.25))+1,
            beginQuarter   = (!chartInfo[cn].total)? 0: Math.floor(sum/(chartInfo[cn].total/4))+1,
            pointA,pointB,pointC,pointD,polyline,text_x,cssClass,sides,andis;

          [ pointA,pointB,pointC,pointD,rotation,polyline,text_x,cssClass ] =
            determineAnglesAndPoints( val, currentQuarter, rotation, sum, chartInfo[cn].total, radius, emptyRadius );

          sum = (sum+val)%chartInfo[cn].total;
          var
            percent = (!chartInfo[cn].total)? 0: Math.round(val/chartInfo[cn].total*10000)/100,
            gText   = {
              'sliceName': sn,
              'price'    : val.toPrice(),
              'percent'  : percent,
              'rotation' : rotation,
              'polyline' : polyline,
              'text_x'   : text_x,
              'cssClass' : cssClass
            },
            dSide_1,dSide_2,dTopSide,dOuterArc,dInnerArc;

          if( val && val===chartInfo[cn].total ){
            [dSide_1,dSide_2] = dSideDemention( pointA, pointB, pointD, pointC, height ),
            dTopSide  = dTopDemention( pointA, pointB, pointC, pointD, radius, emptyRadius, arcFlag, sweepFlag ),
            [dOuterArc,dInnerArc] = dTotalArcDemention( pointB, radius, arcFlag, sweepFlag, height );
          }
          else{
            [dSide_1,dSide_2] = dSideDemention( pointA, pointB, pointD, pointC, height ),
            dTopSide  = dTopDemention( pointA, pointB, pointC, pointD, radius, emptyRadius, arcFlag, sweepFlag ),
            dOuterArc = dArcDemention( pointB, pointC, radius, arcFlag, sweepFlag, height ),
            dInnerArc = emptyRadius == 0? '': dArcDemention( pointA, pointD, emptyRadius, arcFlag, sweepFlag, height );
          }


          if( beginQuarter == 1 ){
            if( sum<chartInfo[cn].total*0.25 ){
              sides = {dSide_2,dOuterArc,dInnerArc,dSide_1,dTopSide,gText};
              andis = '1';
            }
            else if( sum<chartInfo[cn].total*0.5 ){
              sides = {dOuterArc,dSide_1,dSide_2,dInnerArc,dTopSide,gText};
              andis = '1-2';
            }
            else if( sum<chartInfo[cn].total*0.75 ){
              sides = {dSide_1,dInnerArc,dOuterArc,dSide_2,dTopSide,gText};
              andis = '1-2';
            }
            else{
              sides = {dInnerArc,dSide_2,dOuterArc,dSide_1,dTopSide,gText};
              andis = '1-2';
            }
          }
          else if( beginQuarter == 2  ){
            if( sum<chartInfo[cn].total*0.75 ){
              sides = {dSide_1,dOuterArc,dInnerArc,dSide_2,dTopSide,gText};
              andis = ( sum<chartInfo[cn].total*0.5 )? '2': '2-3';
            }
            else{
              sides = {dSide_1,dInnerArc,dSide_2,dOuterArc,dTopSide,gText};
              andis = '2-3';
            }
          }
          else if( beginQuarter == 3 ){
            if( sum<chartInfo[cn].total*0.75 ){
              sides = {dSide_1,dInnerArc,dOuterArc,dSide_2,dTopSide,gText};
              andis = '3';
            }
            else{
              sides = {dSide_1,dInnerArc,dSide_2,dOuterArc,dTopSide,gText};
              andis = '3-4';
            }
          }
          else{
            sides = {dSide_2,dInnerArc,dOuterArc,dSide_1,dTopSide,gText};
            andis = '4';
          }

          quarter[andis].push(sides);
        })

        quarter['1'].reverse();
        quarter['4'].reverse();

        pieSlc[cn] = [].concat(quarter['1-2'],quarter['1'],quarter['4'],quarter['2'],quarter['2-3'],quarter['3'],quarter['3-4']);
        if( !slcClr )
          slcClr = pieSliceColor( quarter, Object.keys(pieSlc[cn]).length-1 );
      });

      Object.keys(pieSlc).map(cn=>{
        pieSlc[cn].map((dementionsObj,k)=>{
          Object.keys(dementionsObj).map(demention=>{
            if( demention=='gText' )
              slcInfo[cn][pieSlc[cn][k].gText.sliceName] = dementionsObj[demention];
            else
              slcD[cn][pieSlc[cn][k].gText.sliceName][demention] = dementionsObj[demention];
          })
        })
      })

      setPieSlices ( pieSlc  )
      setSliceColor( slcClr  )
    },[chartInfo,chartName,radius,emptyRadius,height]);

  useEffect(()=>{
    createSlice()
  },[chartName])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setChartName( mrbgStore.getState().dynamicChartKey[chartID]?.cName )
      setPointName( mrbgStore.getState().dynamicChartKey[chartID]?.pName )
    })
    createSlice()
    return () =>unsubscribe();
  },[])

  return(
    <svg viewBox={`-${radius*4/3} -${radius*4/3} ${radius*8/3} ${radius*8/3}`}>
      {
        pieSlices[chartName]?
          Object.keys(pieSlices[chartName]).map((slices,key)=>{
            return <PieSlice {...{sliceD:pieSlices[chartName][slices],sliceColor:sliceColor[key],chartID,chartName,pointName}} key={key} />
          }):
          ''
      }
    </svg>
  )
}
export function MrbgAbsolutePieChart({id,title}){

  const
    [chartInfo,setChartInfo] = useState( mrbgStore.getState().mrbgVars[id]||{} ),
    [pieSlices,setPieSlices] = useState({}),
    [sliceColor,setSliceColor] = useState({}),
    radius = 350,
    emptyRadius = radius*.4,
    height = radius * 0.12;

  useEffect(() => {

    var
      pieSlc  = {},
      slcClr,
      sum = 0,
      quarter = {
        '1-2': [],
        '1'  : [],
        '4'  : [],
        '2'  : [],
        '2-3': [],
        '3'  : [],
        '3-4': []
      };

    if( chartInfo?.points && Object.values(chartInfo.points).length && Math.max(...Object.values(chartInfo.points))>chartInfo.total*.75 )
      sum = chartInfo.total * .25;

    Object.keys(chartInfo?.points||{}).map(sn=>{

      var
        val            = parseInt(chartInfo.points[sn]) || 0,
        arcFlag        = val>chartInfo.total/2? 1: 0,
        sweepFlag      = 0,
        centerPart     = (val/2+sum)%chartInfo.total,
        rotation       = (!chartInfo.total)? 0: centerPart*-360/chartInfo.total,
        currentQuarter = (!chartInfo.total)? 0: Math.floor(centerPart/(chartInfo.total*0.25))+1,
        beginQuarter   = (!chartInfo.total)? 0: Math.floor(sum/(chartInfo.total/4))+1,
        pointA,pointB,pointC,pointD,polyline,text_x,cssClass,sides,andis;

      [ pointA,pointB,pointC,pointD,rotation,polyline,text_x,cssClass ] =
        determineAnglesAndPoints( val, currentQuarter, rotation, sum, chartInfo.total, radius, emptyRadius );

      sum = (sum+val)%chartInfo.total;
      var
        percent = (!chartInfo.total)? 0: Math.round(val/chartInfo.total*10000)/100,
        gText   = {
          'sliceName': sn,
          'price'    : val.toPrice(),
          'percent'  : percent,
          'rotation' : rotation,
          'polyline' : polyline,
          'text_x'   : text_x,
          'cssClass' : cssClass
        },
        dSide_1,dSide_2,dTopSide,dOuterArc,dInnerArc;

      if( val && val===chartInfo.total ){
        [dSide_1,dSide_2] = dSideDemention( pointA, pointB, pointD, pointC, height ),
          dTopSide  = dTopDemention( pointA, pointB, pointC, pointD, radius, emptyRadius, arcFlag, sweepFlag ),
          [dOuterArc,dInnerArc] = dTotalArcDemention( pointB, radius, arcFlag, sweepFlag, height );
      }
      else{
        [dSide_1,dSide_2] = dSideDemention( pointA, pointB, pointD, pointC, height ),
          dTopSide  = dTopDemention( pointA, pointB, pointC, pointD, radius, emptyRadius, arcFlag, sweepFlag ),
          dOuterArc = dArcDemention( pointB, pointC, radius, arcFlag, sweepFlag, height ),
          dInnerArc = emptyRadius == 0? '': dArcDemention( pointA, pointD, emptyRadius, arcFlag, sweepFlag, height );
      }


      if( beginQuarter == 1 ){
        if( sum<chartInfo.total*0.25 ){
          sides = {dSide_2,dOuterArc,dInnerArc,dSide_1,dTopSide,gText};
          andis = '1';
        }
        else if( sum<chartInfo.total*0.5 ){
          sides = {dOuterArc,dSide_1,dSide_2,dInnerArc,dTopSide,gText};
          andis = '1-2';
        }
        else if( sum<chartInfo.total*0.75 ){
          sides = {dSide_1,dInnerArc,dOuterArc,dSide_2,dTopSide,gText};
          andis = '1-2';
        }
        else{
          sides = {dInnerArc,dSide_2,dOuterArc,dSide_1,dTopSide,gText};
          andis = '1-2';
        }
      }
      else if( beginQuarter == 2  ){
        if( sum<chartInfo.total*0.75 ){
          sides = {dSide_1,dOuterArc,dInnerArc,dSide_2,dTopSide,gText};
          andis = ( sum<chartInfo.total*0.5 )? '2': '2-3';
        }
        else{
          sides = {dSide_1,dInnerArc,dSide_2,dOuterArc,dTopSide,gText};
          andis = '2-3';
        }
      }
      else if( beginQuarter == 3 ){
        if( sum<chartInfo.total*0.75 ){
          sides = {dSide_1,dInnerArc,dOuterArc,dSide_2,dTopSide,gText};
          andis = '3';
        }
        else{
          sides = {dSide_1,dInnerArc,dSide_2,dOuterArc,dTopSide,gText};
          andis = '3-4';
        }
      }
      else{
        sides = {dSide_2,dInnerArc,dOuterArc,dSide_1,dTopSide,gText};
        andis = '4';
      }

      quarter[andis].push(sides);
    });

    quarter['1'].reverse();
    quarter['4'].reverse();

    pieSlc = [].concat(quarter['1-2'],quarter['1'],quarter['4'],quarter['2'],quarter['2-3'],quarter['3'],quarter['3-4']);
    if( !slcClr )
      slcClr = pieSliceColor( quarter, Object.keys(pieSlc).length-1 );

    setPieSlices ( pieSlc  )
    setSliceColor( slcClr  )
  }, [chartInfo]);
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setChartInfo( mrbgStore.getState().mrbgVars[id]||{} )
    })
    mrbgStore.dispatch(hasChart())
    return () =>unsubscribe();
  },[])

  return(
    <div className={chartStyle.pieChartsFrame}>
      <div className={chartStyle.MP_frameH2}>
        <h2>{title}</h2>
      </div>
      <div className={chartStyle.pieChart}>
        <svg viewBox={`-${radius*4/3} -${radius*4/3} ${radius*8/3} ${radius*8/3}`}>
          {
            pieSlices?
              Object.keys(pieSlices).map((slices,key)=>{
                return <PieSlice {...{sliceD:pieSlices[slices],sliceColor:sliceColor[key],id}} key={key} />
              }):
              ''
          }
        </svg>
      </div>
    </div>
  )
}
function determineAnglesAndPoints(val,currentQuarter,rotation,sum,total,radius,emptyRadius){

  var
    begAngle = (!total)? 0: sum*360/total,
    endAngle = (!total)? 0: (sum+val)*360/total,
    middleAngle = (begAngle+endAngle)/2,
    polyline,
    text_x,
    cssClass;

  polyline = [
    Math.cos(deg2rad(middleAngle))*(radius+20)    , Math.sin(deg2rad(middleAngle))*(radius+20)*-1,
    Math.cos(deg2rad(middleAngle))*(radius+20)*1.5, Math.sin(deg2rad(middleAngle))*(radius+20)*-1.5
  ];

  if( currentQuarter == 1 ){
    cssClass = '';
    text_x = 20;
  }
  else if( currentQuarter == 2 ){
    rotation -= 180;
    text_x    = -20;
    cssClass  = 'rtl';
  }
  else if( currentQuarter == 3 ){
    rotation -= 180;
    text_x    = -20;
    cssClass  = 'rtl';
  }
  else{
    rotation -= 360;
    text_x    = 20;
    cssClass  = '';
  }

  var
    pointA = [Math.cos(deg2rad(begAngle))*emptyRadius, Math.sin(deg2rad(begAngle))*emptyRadius*-1],
    pointB = [Math.cos(deg2rad(begAngle))*radius     , Math.sin(deg2rad(begAngle))*radius     *-1],
    pointC = [Math.cos(deg2rad(endAngle))*radius     , Math.sin(deg2rad(endAngle))*radius     *-1],
    pointD = [Math.cos(deg2rad(endAngle))*emptyRadius, Math.sin(deg2rad(endAngle))*emptyRadius*-1];

  return [ pointA,pointB,pointC,pointD,rotation,polyline,text_x,cssClass ];
}
function deg2rad(deg){
  return deg * (Math.PI/180);
}
function dSideDemention(pointA, pointB, pointC, pointD, height){
  return [
    `M${pointA} L${pointB} v${height} L${pointA[0]},${pointA[1]+height} z`,
    `M${pointD} L${pointC} v${height} L${pointD[0]},${pointD[1]+height} z`,
  ];
}
function dTopDemention(pointA, pointB, pointC, pointD, radius, emptyRadius, arcFlag, sweepFlag){

  var
    reverseSweepFlag = ( sweepFlag )? 0: 1;
  emptyRadius =
    ( emptyRadius )?
      ` A${emptyRadius},${emptyRadius} 0,${arcFlag},${reverseSweepFlag} ${pointA}`:
      '';

  return `M${pointA} L${pointB} A${radius},${radius} 0,${arcFlag},${sweepFlag} ${pointC} L${pointD+emptyRadius} z`;
}
function dTotalArcDemention(point, radius, arcFlag, sweepFlag, height){

  var reverseSweepFlag = ( sweepFlag )? 0: 1;
  return [
    `
      M${point} A${radius},${radius} 0 ${arcFlag},${sweepFlag} ${point[0]*-1},${point[1]} v${height} A${radius},${radius} 0 ${arcFlag},${reverseSweepFlag} ${point[0]},${point[1]+height} z
      M${point} A${radius},${radius} 0 ${arcFlag},${reverseSweepFlag} ${point[0]*-1},${point[1]} v${height} A${radius},${radius} 0 ${arcFlag},${sweepFlag} ${point[0]},${point[1]+height} z
    `,
    `
      M${point[0]/2},${point[1]} A${radius/2},${radius/2} 0 ${arcFlag},${sweepFlag} ${point[0]/-2},${point[1]} v${height} A${radius/2},${radius/2} 0 ${arcFlag},${reverseSweepFlag} ${point[0]/2},${point[1]+height} z
      M${point[0]/2},${point[1]} A${radius/2},${radius/2} 0 ${arcFlag},${reverseSweepFlag} ${point[0]/-2},${point[1]} v${height} A${radius/2},${radius/2} 0 ${arcFlag},${sweepFlag} ${point[0]/2},${point[1]+height} z
    `
  ];
}
function dArcDemention(pointA, pointB, radius, arcFlag, sweepFlag, height){
  var reverseSweepFlag = ( sweepFlag )? 0: 1;
  return `M${pointA} A${radius},${radius} 0 ${arcFlag},${sweepFlag} ${pointB} L${pointB[0]},${pointB[1]+height} A${radius},${radius} 0 ${arcFlag},${reverseSweepFlag} ${pointA[0]},${pointA[1]+height} z`
}
function pieSliceColor( quarter, allCnt ){

  var
    colorLen = 22,
    sliceColor = [],
    cnt = {};

  Object.keys(quarter).map(key=>{
    cnt[key] = quarter[key].length;
  })

  // FOR QUARTER 1_2 ___________________________________
  if( cnt['1-2'] )
    sliceColor.push( cnt[1]%colorLen );

  // FOR QUARTER 1 _____________________________________
  for( let i=0; i<cnt['1']; i++ )
    sliceColor.push( (cnt['1']-cnt['1-2']-i)%colorLen );

  // FOR QUARTER 4 ______________________________________
  for( let i=0; i<cnt['4']; i++ )
    sliceColor.push( (allCnt-i)%colorLen );

  // FOR QUARTER 2, 2-3, 3, 3-4 _________________________
  var
    fc = cnt['1']+cnt['1-2'],
    mc = cnt['2']+cnt['2-3']+cnt['3']+cnt['3-4'];
  for( let i=0; i<mc; i++ )
    sliceColor.push( (fc+i)%colorLen );

  return sliceColor;
}
function PieSlice({sliceD,sliceColor,chartID,chartName,pointName}){

  const
    topColor  = ['#4C8EFA','#4376CA','#395E9A','#30466A','#4E3292','#6B1FBA','#890BE2','#A114EA','#B91DF1','#D126F8','#E41BB8','#F70F77','#F03','#FF801A','#FFC00D','#FF0','#DDFF01','#BBFF02','#76FF03','#5AB50D','#3E6C18','#457D89'],
    sideColor = ['#2A6CD8','#2154A8','#173A78','#102448','#2C1070','#490D98','#6709C0','#8002C8','#970BD0','#B004D6','#B20996','#D50D55','#D01','#DD6008','#DDA00B','#DD0','#BBDD00','#99DD00','#54DD01','#38930B','#1C4A06','#235B67'],
    clickEvent =
      chartName?
        {onClick:()=>mrbgStore.dispatch(setChartKey({id:chartID,chartKey:chartName,pointKey:sliceD.gText.sliceName}))}:
        {};

    return <g className={sliceD.gText.sliceName==pointName? chartStyle.activeSlice: ''} {...clickEvent}>
      {
        Object.keys(sliceD).map((demention,k)=>{
          if( demention!=='gText' ){
            var
              fill,
              cls;
            if( demention=='dTopSide' ){
              cls  = 'topSlice';
              fill = topColor[sliceColor];
            }
            else{
              cls  = 'sideSlice';
              fill = sideColor[sliceColor];
            }
            return <path className={chartStyle[cls]} d={sliceD[demention]} fill={fill} style={{stroke:'#CCC'}} key={k}/>
          }
          else if( !chartName ){
            const {polyline, text_x, sliceName, price, percent, cssClass} = sliceD.gText;

            return (
              <g key={k}>
                <polyline points={`${polyline[0]},${polyline[1]} ${polyline[2]},${polyline[3]} ${polyline[2]+text_x},${polyline[3]}`} style={{strokeWidth:2}}/>
                <text x={polyline[2]+text_x*2} y={polyline[3]} className={cssClass} alignmentBaseline="middle" textAnchor={cssClass=== 'rtl'? 'end': 'start'} fill="#000">
                  <tspan x={polyline[2]+text_x*2} dy="-60px">{sliceName}</tspan>
                  <tspan x={polyline[2]+text_x*2} dy="60px">{price}</tspan>
                  <tspan x={polyline[2]+text_x*2} dy="60px">({percent}%)</tspan>
                </text>
              </g>
            )
          }
        })
      }
    </g>
}
export default MrbgPieChart;